"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateClauseCoverage = exports.generateClauseCoverageHTML = exports.generateHTML = exports.sortStatements = exports.objToCSS = exports.cqlLogicUncoveredUncoverageClauseStyle = exports.cqlLogicUncoveredClauseStyle = exports.cqlLogicClauseCoveredStyle = exports.cqlLogicClauseFalseStyle = exports.cqlLogicClauseTrueStyle = void 0;
const handlebars_1 = __importDefault(require("handlebars"));
const Enums_1 = require("../types/Enums");
const main_1 = __importDefault(require("../templates/main"));
const clause_1 = __importDefault(require("../templates/clause"));
const CustomErrors_1 = require("../types/errors/CustomErrors");
const lodash_1 = require("lodash");
exports.cqlLogicClauseTrueStyle = {
    'background-color': '#ccebe0',
    color: '#20744c',
    'border-bottom-color': '#20744c',
    'border-bottom-style': 'solid',
    'border-bottom-width': '0.35em'
};
exports.cqlLogicClauseFalseStyle = {
    'background-color': '#edd8d0',
    color: '#a63b12',
    'border-bottom-color': '#a63b12',
    'border-bottom-style': 'double',
    'border-bottom-width': '0.35em'
};
exports.cqlLogicClauseCoveredStyle = {
    'background-color': '#daeaf5',
    color: '#004e82'
};
exports.cqlLogicUncoveredClauseStyle = {
    'background-color': 'white',
    color: 'black'
};
exports.cqlLogicUncoveredUncoverageClauseStyle = {
    'background-color': '#edd8d0',
    color: '#a63b12'
};
/**
 * Convert JS object to CSS Style string
 *
 * @param obj JS object representing CSS styles
 * @returns semi-colon separated string of CSS styles for style attribute
 */
function objToCSS(obj) {
    return Object.entries(obj)
        .map(([k, v]) => `${k}:${v}`)
        .join(';');
}
exports.objToCSS = objToCSS;
const main = handlebars_1.default.compile(main_1.default);
handlebars_1.default.registerPartial('clause', clause_1.default);
// text values in annotations show up as an array of strings
handlebars_1.default.registerHelper('concat', s => s.join(''));
// apply highlighting style based on clause result
handlebars_1.default.registerHelper('highlightClause', (localId, context) => {
    const libraryName = context.data.root.libraryName;
    const clauseResults = context.data.root.clauseResults;
    const clauseResult = clauseResults.find(result => result.libraryName === libraryName && result.localId === localId);
    if (clauseResult) {
        if (clauseResult.final === Enums_1.FinalResult.TRUE) {
            return objToCSS(exports.cqlLogicClauseTrueStyle);
        }
        else if (clauseResult.final === Enums_1.FinalResult.FALSE) {
            return objToCSS(exports.cqlLogicClauseFalseStyle);
        }
    }
    return '';
});
// apply highlighting style to covered clauses
handlebars_1.default.registerHelper('highlightCoverage', (localId, context) => {
    const libraryName = context.data.root.libraryName;
    const clauseResults = context.data.root.clauseResults;
    const clauseResult = clauseResults.find(result => result.libraryName === libraryName && result.localId === localId);
    if (clauseResult) {
        if (clauseResult.final === Enums_1.FinalResult.TRUE) {
            return objToCSS(exports.cqlLogicClauseCoveredStyle);
        }
        else if (clauseResult.final === Enums_1.FinalResult.FALSE || clauseResult.final === Enums_1.FinalResult.UNHIT) {
            return objToCSS(exports.cqlLogicUncoveredClauseStyle);
        }
    }
    return '';
});
// apply highlighting style to uncovered clauses
handlebars_1.default.registerHelper('highlightUncoverage', (localId, context) => {
    const libraryName = context.data.root.libraryName;
    if (context.data.root.uncoveredClauses.some(result => result.libraryName === libraryName && result.localId === localId)) {
        // Mark with red styling if clause is found in uncoverage list
        return objToCSS(exports.cqlLogicUncoveredUncoverageClauseStyle);
    }
    else if (context.data.root.coveredClauses.some(result => result.libraryName === libraryName && result.localId === localId)) {
        // Mark with white (clear out styling) if the clause is in coverage list
        return objToCSS(exports.cqlLogicUncoveredClauseStyle);
    }
    // If this clause has no results then it should not be styled
    return '';
});
/**
 * Sort statements into population, then non-functions, then functions
 */
function sortStatements(measure, groupId, statements) {
    var _a, _b, _c;
    const group = ((_a = measure.group) === null || _a === void 0 ? void 0 : _a.find(g => g.id === groupId)) || ((_b = measure.group) === null || _b === void 0 ? void 0 : _b[0]);
    const populationOrder = [
        Enums_1.PopulationType.IPP,
        Enums_1.PopulationType.DENOM,
        Enums_1.PopulationType.DENEX,
        Enums_1.PopulationType.DENEXCEP,
        Enums_1.PopulationType.NUMER,
        Enums_1.PopulationType.NUMEX,
        Enums_1.PopulationType.MSRPOPL,
        Enums_1.PopulationType.MSRPOPLEX,
        Enums_1.PopulationType.OBSERV
    ];
    // this is a lookup of cql expression identifier -> population type
    const populationIdentifiers = {};
    (_c = group === null || group === void 0 ? void 0 : group.population) === null || _c === void 0 ? void 0 : _c.forEach(p => {
        var _a, _b;
        if (((_b = (_a = p.code) === null || _a === void 0 ? void 0 : _a.coding) === null || _b === void 0 ? void 0 : _b[0].code) !== undefined) {
            populationIdentifiers[p.criteria.expression] = p.code.coding[0].code;
        }
    });
    function populationCompare(a, b) {
        return (populationOrder.indexOf(populationIdentifiers[a.statementName]) -
            populationOrder.indexOf(populationIdentifiers[b.statementName]));
    }
    function alphaCompare(a, b) {
        return a.statementName <= b.statementName ? -1 : 1;
    }
    statements.sort((a, b) => {
        // if population statement, use population or send to beginning
        if (a.statementName in populationIdentifiers) {
            return b.statementName in populationIdentifiers ? populationCompare(a, b) : -1;
        }
        if (b.statementName in populationIdentifiers)
            return 1;
        // if function, alphabetize or send to end
        if (a.isFunction) {
            return b.isFunction ? alphaCompare(a, b) : 1;
        }
        if (b.isFunction)
            return -1;
        // if no function or population statement, alphabetize
        return alphaCompare(a, b);
    });
}
exports.sortStatements = sortStatements;
/**
 * Generate HTML structure based on ELM annotations in relevant statements
 *
 * @param measure measure used for calculation
 * @param elmLibraries main ELM and dependencies to lookup statements
 * @param statementResults StatementResult array from calculation
 * @param clauseResults ClauseResult array from calculation
 * @param groupId ID of population group
 * @param options Calculation Options
 * @returns string of HTML representing the clauses for this group
 */
function generateHTML(measure, elmLibraries, statementResults, clauseResults, groupId, options) {
    const relevantStatements = statementResults.filter(s => s.relevance !== Enums_1.Relevance.NA);
    if (!(options === null || options === void 0 ? void 0 : options.disableHTMLOrdering)) {
        sortStatements(measure, groupId, relevantStatements);
    }
    let overallHTML = `<div><h2>Population Group: ${groupId}</h2>`;
    relevantStatements.forEach(s => {
        const matchingLibrary = elmLibraries.find(e => e.library.identifier.id === s.libraryName);
        if (!matchingLibrary) {
            throw new CustomErrors_1.UnexpectedResource(`Could not find library ${s.libraryName} for statement ${s.statementName}`);
        }
        const matchingExpression = matchingLibrary.library.statements.def.find(e => e.name === s.statementName);
        if (!matchingExpression) {
            throw new CustomErrors_1.UnexpectedProperty(`No statement ${s.statementName} found in library ${s.libraryName}`);
        }
        if (matchingExpression.annotation) {
            const statementHTML = main(Object.assign(Object.assign({ libraryName: s.libraryName, statementName: s.statementName, clauseResults: clauseResults }, matchingExpression.annotation[0].s), { highlightLogic: true }));
            overallHTML += statementHTML;
            if (options === null || options === void 0 ? void 0 : options.buildStatementLevelHTML) {
                s.statementLevelHTML = statementHTML;
            }
        }
    });
    overallHTML += '</div>';
    return overallHTML;
}
exports.generateHTML = generateHTML;
/**
 * Generate HTML structure with clause coverage highlighting for all clauses
 * based on ELM annotations in relevant statements
 *
 * @param measure measure used for calculation
 * @param elmLibraries main ELM and dependencies to lookup statements
 * @param executionResults array of detailed population group results across
 * all patients
 * @param disableHTMLOrdering disables CQL statement sorting
 * @returns a lookup object where the key is the groupId and the value is the
 * clause coverage HTML
 */
function generateClauseCoverageHTML(measure, elmLibraries, executionResults, options) {
    const groupResultLookup = {};
    const coverageHtmlGroupLookup = {};
    const uncoverageHtmlGroupLookup = {};
    const coverageDetailsGroupLookup = {};
    // get the detailed result for each group within each patient and add it
    // to the key in groupResults that matches the groupId
    executionResults.forEach(result => {
        var _a;
        (_a = result.detailedResults) === null || _a === void 0 ? void 0 : _a.forEach(detailedResult => {
            if (!groupResultLookup[detailedResult.groupId]) {
                groupResultLookup[detailedResult.groupId] = [detailedResult];
            }
            else {
                groupResultLookup[detailedResult.groupId].push(detailedResult);
            }
        });
    });
    // go through the lookup object of each of the groups with their total
    // detailedResults and calculate the clause coverage html for each group
    Object.entries(groupResultLookup).forEach(([groupId, detailedResults]) => {
        // Grab the statement results from just the first patient since just only need the names
        // of the statements and whether or not their relevance is NA
        const flattenedStatementResults = detailedResults[0].statementResults;
        const flattenedClauseResults = detailedResults.flatMap(c => (c.clauseResults ? c.clauseResults : []));
        // Filter out any statement results where the statement relevance is NA
        const uniqueRelevantStatements = flattenedStatementResults.filter(s => s.relevance !== Enums_1.Relevance.NA);
        if (!options.disableHTMLOrdering) {
            sortStatements(measure, groupId, uniqueRelevantStatements);
        }
        // assemble array of statement annotations to be templated to HTML
        const statementAnnotations = [];
        uniqueRelevantStatements.forEach(s => {
            const matchingLibrary = elmLibraries.find(e => e.library.identifier.id === s.libraryName);
            if (!matchingLibrary) {
                throw new CustomErrors_1.UnexpectedResource(`Could not find library ${s.libraryName} for statement ${s.statementName}`);
            }
            const matchingExpression = matchingLibrary.library.statements.def.find(e => e.name === s.statementName);
            if (!matchingExpression) {
                throw new CustomErrors_1.UnexpectedProperty(`No statement ${s.statementName} found in library ${s.libraryName}`);
            }
            if (matchingExpression.annotation) {
                statementAnnotations.push({
                    libraryName: s.libraryName,
                    statementName: s.statementName,
                    annotation: matchingExpression.annotation
                });
            }
        });
        const clauseCoverage = calculateClauseCoverage(uniqueRelevantStatements, flattenedClauseResults);
        const uniqueCoverageClauses = clauseCoverage.coveredClauses.concat(clauseCoverage.uncoveredClauses);
        // setup initial html for coverage
        let coverageHtmlString = `<div><h2> ${groupId} Clause Coverage: ${clauseCoverage.percentage}%</h2>`;
        // setup initial html for uncoverage
        let uncoverageHtmlString = '';
        if (options.calculateClauseUncoverage) {
            uncoverageHtmlString = `<div><h2> ${groupId} Clause Uncoverage: ${clauseCoverage.uncoveredClauses.length} of ${clauseCoverage.coveredClauses.length + clauseCoverage.uncoveredClauses.length} clauses</h2>`;
        }
        // generate HTML clauses using hbs template for each annotation
        statementAnnotations.forEach(a => {
            coverageHtmlString += main(Object.assign(Object.assign({ libraryName: a.libraryName, statementName: a.statementName, clauseResults: uniqueCoverageClauses }, a.annotation[0].s), { highlightCoverage: true }));
            // calculate for uncoverage
            if (options.calculateClauseUncoverage) {
                uncoverageHtmlString += main(Object.assign(Object.assign({ libraryName: a.libraryName, statementName: a.statementName, uncoveredClauses: clauseCoverage.uncoveredClauses, coveredClauses: clauseCoverage.coveredClauses }, a.annotation[0].s), { highlightUncoverage: true }));
            }
        });
        coverageHtmlString += '</div>';
        uncoverageHtmlString += '</div>';
        coverageHtmlGroupLookup[groupId] = coverageHtmlString;
        if (options.calculateClauseUncoverage) {
            uncoverageHtmlGroupLookup[groupId] = uncoverageHtmlString;
        }
        // If details on coverage are requested, tally them up and add them to the map.
        if (options.calculateCoverageDetails) {
            coverageDetailsGroupLookup[groupId] = {
                totalClauseCount: clauseCoverage.coveredClauses.length + clauseCoverage.uncoveredClauses.length,
                coveredClauseCount: clauseCoverage.coveredClauses.length,
                uncoveredClauseCount: clauseCoverage.uncoveredClauses.length,
                uncoveredClauses: clauseCoverage.uncoveredClauses.map(uncoveredClause => {
                    return {
                        localId: uncoveredClause.localId,
                        libraryName: uncoveredClause.libraryName,
                        statementName: uncoveredClause.statementName
                    };
                })
            };
        }
    });
    return Object.assign(Object.assign({ coverage: coverageHtmlGroupLookup }, (options.calculateClauseUncoverage && { uncoverage: uncoverageHtmlGroupLookup })), (options.calculateCoverageDetails && { details: coverageDetailsGroupLookup }));
}
exports.generateClauseCoverageHTML = generateClauseCoverageHTML;
/**
 * Calculates clause coverage as the percentage of relevant clauses with FinalResult.TRUE
 * out of all relevant clauses.
 * @param relevantStatements StatementResults array from calculation filtered to relevant statements
 * @param clauseResults ClauseResult array from calculation
 * @returns percentage out of 100, represented as a string
 */
function calculateClauseCoverage(relevantStatements, clauseResults) {
    // find all relevant clauses using statementName and libraryName from relevant statements
    const allRelevantClauses = clauseResults.filter(c => relevantStatements.some(s => s.statementName === c.statementName && s.libraryName === c.libraryName && !s.isFunction));
    // get all unique clauses to use as denominator in percentage calculation
    const allUniqueClauses = (0, lodash_1.uniqWith)(allRelevantClauses, (c1, c2) => c1.libraryName === c2.libraryName && c1.localId === c2.localId);
    const coveredClauses = (0, lodash_1.uniqWith)(allRelevantClauses.filter(clause => clause.final === Enums_1.FinalResult.TRUE), (c1, c2) => c1.libraryName === c2.libraryName && c1.localId === c2.localId);
    const uncoveredClauses = allUniqueClauses.filter(c => {
        return !coveredClauses.find(coveredC => c.libraryName === coveredC.libraryName && c.localId === coveredC.localId);
    });
    return {
        percentage: ((coveredClauses.length / allUniqueClauses.length) * 100).toPrecision(3),
        coveredClauses,
        uncoveredClauses
    };
}
exports.calculateClauseCoverage = calculateClauseCoverage;
//# sourceMappingURL=HTMLBuilder.js.map